import * as cryptoBrowser from 'crypto-browserify';

// Provide a browser-compatible implementation of Node's crypto functions
export const crypto = {
  randomBytes: (size: number): Buffer => {
    return cryptoBrowser.randomBytes(size);
  },
  
  pbkdf2Sync: (password: string, salt: string, iterations: number, keylen: number, digest: string): Buffer => {
    // Ensure salt is converted to buffer if it's a string
    let saltBuffer: Buffer;
    if (typeof salt === 'string') {
      // Convert hexadecimal string to Buffer
      saltBuffer = Buffer.from(salt, 'hex');
    } else if (Buffer.isBuffer(salt)) {
      saltBuffer = salt;
    } else {
      // If salt is undefined or null, generate a new one
      saltBuffer = cryptoBrowser.randomBytes(16);
    }
    
    return cryptoBrowser.pbkdf2Sync(password, saltBuffer, iterations, keylen, digest);
  }
};

export default crypto; 